export const teachingPlatformApi = "/teachingPlatformService/api";
export const studyService = "/studyService/api";
export const operateService = "/operateService/api";
export const userService = "/userService/api";
